import React from 'react';
import {Beforeunload} from 'react-beforeunload';
import {Prompt} from 'react-router-dom';

export function PromptOnNavigation({when, message}) {
  return <React.Fragment>
    <Prompt when={when} message={message} />
    <Beforeunload onBeforeunload={() => when ? message : null} />
  </React.Fragment>;
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/PromptOnNavigation.jsx